import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { ArrowLeft, Trash2, MapPin, FileText, AlertCircle, Phone, User, Home, Package, DollarSign, Eye, HelpCircle, CheckCircle } from "lucide-react";
import MultiProductDialog from './MultiProductDialog';
import FutureDatePicker from '../analytics/FutureDatePicker';

const brand = {
  primary: "#B1336E",
  accentGold: "#E6B43C",
  accentGreen: "#67A43C",
};

const DISTRICTS = [
  'Ate', 'Barranco', 'Breña', 'Carabayllo', 'Chorrillos', 'Comas', 'El Agustino',
  'Independencia', 'Jesús María', 'La Molina', 'La Victoria', 'Lince', 'Los Olivos',
  'Magdalena del Mar', 'Miraflores', 'Pueblo Libre', 'Puente Piedra', 'Rímac',
  'San Borja', 'San Isidro', 'San Juan de Lurigancho', 'San Juan de Miraflores',
  'San Luis', 'San Martín de Porres', 'San Miguel', 'Santa Anita', 'Santiago de Surco',
  'Surquillo', 'Villa El Salvador', 'Villa Maria del Triunfo', 'Cercado de Lima',
  'Callao', 'Bellavista', 'Carmen de La Legua Reynoso', 'La Perla', 'La Punta',
  'Ventanilla', 'Ayacucho', 'Arequipa', 'Juliaca', 'Puno', 'Chiclayo', 'Cusco',
  'Huancayo', 'Chimbote', 'Piura', 'Trujillo',
];

export default function Entrega({ userId, setActiveComponent }) {
  const [user, setUser] = useState(null);
  const [deliveryDate, setDeliveryDate] = useState('');
  const [additionalNotes, setAdditionalNotes] = useState('');
  const [recipientName, setRecipientName] = useState('');
  const [address, setAddress] = useState('');
  const [recipientPhone, setRecipientPhone] = useState('');
  const [district, setDistrict] = useState('');
  const [charge, setCharge] = useState('');
  const [items, setItems] = useState([]);
  const [coordsInput, setCoordsInput] = useState('');
  const [provisionalLatitude, setProvisionalLatitude] = useState('');
  const [provisionalLongitude, setProvisionalLongitude] = useState('');
  const [driverId, setDriverId] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [busy, setBusy] = useState(false);
  const [openProductsDialog, setOpenProductsDialog] = useState(false);

  const openDialogProduct = () => setOpenProductsDialog(true);
  const closeDialogProduct = () => setOpenProductsDialog(false);
  const handleSaveItems = (rows) => {
    setItems(rows);
  };

  const driver_1 = ["Chorrillos", "San Juan de Miraflores", "Villa El Salvador", "Villa Maria del Triunfo"];
  const driver_2 = ["Comas", "Independencia", "San Martín de Porres", "Los Olivos", "Rímac"];
  const driver_3 = ["Ate", "Santa Anita", "La Molina", "San Luis"];
  const driver_4 = ["Callao", "Jesús María", "Bellavista", "Lince", "Magdalena del Mar", "Carmen de la Legua", "La Perla", "La Punta", "Cercado de Lima", "San Miguel", "Pueblo Libre", "Breña"];
  const driver_5 = ["Puente Piedra", "Carabayllo", "Ventanilla", "Ancon", "Santa Rosa"];
  const driver_6 = ["San Isidro", "San Borja", "Miraflores", "Surquillo", "Santiago de Surco", "Barranco"];
  const driver_7 = ["El Agustino", "La Victoria", "San Juan de Lurigancho"];
  const driver_10 = ["Ayacucho"];
  const driver_11 = ["Arequipa"];
  const driver_12 = ["Juliaca"];
  const driver_13 = ["Puno"];
  const driver_14 = ["Chiclayo"];
  const driver_15 = ["Cusco"];
  const driver_16 = ["Huancayo"];
  const driver_17 = ["Chimbote"];
  const driver_18 = ["Piura"];
  const driver_19 = ["Trujillo"];

  useEffect(() => {
    const fetchUserData = () => {
      axios.get(`${process.env.REACT_APP_API_URL}/api/user/${userId}`)
        .then(response => setUser(response.data))
        .catch(error => console.error('Error fetching data:', error));
    };
    fetchUserData();
    const intervalId = setInterval(fetchUserData, 5000);
    return () => clearInterval(intervalId);
  }, [userId]);

  useEffect(() => {
    if (district) {
      if (driver_1.includes(district)) setDriverId(7);
      else if (driver_2.includes(district)) setDriverId(3);
      else if (driver_3.includes(district)) setDriverId(6);
      else if (driver_4.includes(district)) setDriverId(54);
      else if (driver_5.includes(district)) setDriverId(183);
      else if (driver_6.includes(district)) setDriverId(164);
      else if (driver_7.includes(district)) setDriverId(119);
      else if (driver_10.includes(district)) setDriverId(450);
      else if (driver_11.includes(district)) setDriverId(451);
      else if (driver_12.includes(district)) setDriverId(452);
      else if (driver_13.includes(district)) setDriverId(453);
      else if (driver_14.includes(district)) setDriverId(454);
      else if (driver_15.includes(district)) setDriverId(455);
      else if (driver_16.includes(district)) setDriverId(456);
      else if (driver_17.includes(district)) setDriverId(458);
      else if (driver_18.includes(district)) setDriverId(459);
      else if (driver_19.includes(district)) setDriverId(460);
      else setDriverId(null);
    }
  }, [district]);

  const handleCoordsChange = (e) => {
    const val = e.target.value;
    setCoordsInput(val);
    const m = val.match(/^\s*(-?\d+(\.\d+)?)\s*,\s*(-?\d+(\.\d+)?)\s*$/);
    if (m) {
      setProvisionalLatitude(m[1]);
      setProvisionalLongitude(m[3]);
    } else {
      setProvisionalLatitude('');
      setProvisionalLongitude('');
    }
  };

  const openInGoogleMaps = () => {
    if (provisionalLatitude && provisionalLongitude) {
      window.open(`https://www.google.com/maps?q=${provisionalLatitude},${provisionalLongitude}`, '_blank');
    }
  };

  const showCoordsHelp = () => {
    alert(
      "Por favor introduce las coordenadas en el siguiente formato:\n\n" +
      "Ejemplo: -12.00156295, -77.05527454\n\n" +
      "¿Cómo obtenerlo en Google Maps?\n" +
      "1. Abre Google Maps.\n" +
      "2. Haz clic derecho en el lugar exacto o sobre el pin rojo.\n" +
      "3. Selecciona la opción que muestra los números (las coordenadas).\n" +
      "4. Copia ese texto y pégalo aquí exactamente como aparece.\n" +
      "5. Haz clic en el ícono del ojo 👁️ para verificar que la ubicación ingresada sea la correcta."
    );
  };

  const handleConfirmClick = () => {
    if (!recipientName) {
      setErrorMessage('Por favor, ingresa el nombre del destinatario.');
      return;
    }
    if (!recipientPhone) {
      setErrorMessage('Por favor, ingresa el número de teléfono del destinatario.');
      return;
    }
    if (!district) {
      setErrorMessage('Por favor, selecciona el distrito de entrega.');
      return;
    }
    if (!deliveryDate) {
      setErrorMessage('Por favor, selecciona la fecha de entrega.');
      return;
    }
    if (!items.length) {
      setErrorMessage('Por favor, especifica qué producto estás enviando.');
      return;
    }
    if (!address) {
      setErrorMessage('Por favor, ingresa una dirección o referencia de entrega.');
      return;
    }
    setErrorMessage('');
    setIsModalOpen(true);
  };

  const handleConfirm = async () => {
    setIsModalOpen(false);
    setBusy(true);

    try {
      await axios.post(`${process.env.REACT_APP_API_URL}/api/entrega`, {
        user_id: localStorage.getItem('user_id'),
        delivery_date: deliveryDate,
        recipient_name: recipientName,
        recipient_phone: recipientPhone,
        district: district,
        driver_id: driverId,
        charge: charge === '' || charge === null ? 0 : parseFloat(charge),
        additional_notes: additionalNotes,
        address: address,
        provisional_latitude: provisionalLatitude,
        provisional_longitude: provisionalLongitude,
        items: items.map(i => ({ sku: i.sku, quantity: i.quantity }))
      });
      
      // Show success modal
      setShowSuccessModal(true);
    } catch (error) {
      console.error('Error creating entrega:', error);
      setErrorMessage('Error al crear la entrega. Por favor, intenta de nuevo.');
    } finally {
      setBusy(false);
    }
  };

  const resetForm = () => {
    setDeliveryDate('');
    setRecipientName('');
    setRecipientPhone('');
    setDistrict('');
    setAddress('');
    setCharge('');
    setItems([]);
    setCoordsInput('');
    setProvisionalLatitude('');
    setProvisionalLongitude('');
    setAdditionalNotes('');
    setDriverId(null);
    setErrorMessage('');
    setShowSuccessModal(false);
  };

  const handleAddAnother = () => {
    resetForm();
  };

  return (
    <div className="h-screen w-full bg-gradient-to-br from-slate-50 to-slate-100 flex flex-col overflow-hidden">
      {/* Header */}
      <div className="bg-white border-b border-slate-200 shadow-sm">
        <div className="mx-auto max-w-4xl px-4 py-3 sm:px-6">
          <div className="flex items-center justify-between">
            <button
              onClick={() => setActiveComponent('Analytics')}
              className="inline-flex items-center gap-2 rounded-lg px-3 py-2 text-sm font-medium text-slate-700 hover:bg-slate-100 transition-colors"
            >
              <ArrowLeft className="h-4 w-4" />
              <span className="hidden sm:inline">Volver</span>
            </button>
            <h1 className="text-lg sm:text-xl font-bold font-montserrat" style={{ color: brand.primary }}>
              Tu Entrega
            </h1>
            <div className="w-20"></div>
          </div>
        </div>
      </div>

      {/* Content */}
      <div className="flex-1 overflow-y-auto">
        <div className="mx-auto max-w-4xl px-4 py-6 sm:px-6">
          <div className="rounded-2xl bg-white shadow-lg border border-slate-200">
            <div className="p-6 space-y-5">
              {/* Fecha */}
              <FutureDatePicker
                selectedDate={deliveryDate}
                onDateChange={setDeliveryDate}
              />

              {/* Nombre */}
              <div>
                <label className="flex items-center gap-2 mb-3 text-sm font-semibold text-slate-800 font-montserrat">
                  <User className="h-4 w-4" style={{ color: brand.accentGold }} />
                  Nombre del destinatario *
                </label>
                <input
                  type="text"
                  value={recipientName}
                  onChange={(e) => {
                    setRecipientName(e.target.value);
                    setErrorMessage('');
                  }}
                  placeholder="Nombre completo"
                  className="w-full rounded-xl border-2 border-slate-200 bg-white px-4 py-3 text-sm focus:outline-none focus:border-[#E6B43C] transition-all font-montserrat"
                />
              </div>

              {/* Teléfono */}
              <div>
                <label className="flex items-center gap-2 mb-3 text-sm font-semibold text-slate-800 font-montserrat">
                  <Phone className="h-4 w-4" style={{ color: brand.accentGreen }} />
                  Teléfono del destinatario *
                </label>
                <div className="flex items-center gap-2 w-full rounded-xl border-2 border-slate-200 bg-white px-4 py-3 focus-within:border-[#67A43C] transition-all">
                  <span className="text-sm text-slate-600 font-montserrat">🇵🇪 +51</span>
                  <input
                    type="tel"
                    value={recipientPhone}
                    onChange={(e) => {
                      const digits = e.target.value.replace(/\D/g, '').slice(0, 9);
                      setRecipientPhone(digits);
                      setErrorMessage('');
                    }}
                    placeholder="987654321"
                    maxLength={9}
                    className="flex-1 outline-none text-sm font-montserrat"
                  />
                </div>
              </div>

              {/* Dirección */}
              <div>
                <label className="flex items-center gap-2 mb-3 text-sm font-semibold text-slate-800 font-montserrat">
                  <Home className="h-4 w-4" style={{ color: brand.primary }} />
                  Dirección *
                </label>
                <input
                  type="text"
                  value={address}
                  onChange={(e) => {
                    setAddress(e.target.value);
                    setErrorMessage('');
                  }}
                  placeholder="Calle, número..."
                  className="w-full rounded-xl border-2 border-slate-200 bg-white px-4 py-3 text-sm focus:outline-none focus:border-[#B1336E] transition-all font-montserrat"
                />
              </div>

              {/* Coordenadas */}
              <div>
                <label className="flex items-center gap-2 mb-3 text-sm font-semibold text-slate-800 font-montserrat">
                  <MapPin className="h-4 w-4" style={{ color: brand.accentGold }} />
                  Coordenadas *
                </label>
                <div className="relative">
                  <input
                    type="text"
                    value={coordsInput}
                    onChange={handleCoordsChange}
                    placeholder="Ej: -12.00156295, -77.05527454"
                    className="w-full rounded-xl border-2 border-slate-200 bg-white px-4 py-3 pr-20 text-sm focus:outline-none focus:border-[#E6B43C] transition-all font-montserrat"
                  />
                  <div className="absolute right-2 top-1/2 -translate-y-1/2 flex gap-2">
                    <button
                      type="button"
                      onClick={showCoordsHelp}
                      className="p-1.5 hover:bg-slate-100 rounded-lg transition-colors"
                      title="Ayuda con coordenadas"
                    >
                      <HelpCircle className="h-4 w-4 text-slate-500" />
                    </button>
                    <button
                      type="button"
                      onClick={openInGoogleMaps}
                      disabled={!provisionalLatitude || !provisionalLongitude}
                      className={`p-1.5 rounded-lg transition-colors ${
                        provisionalLatitude && provisionalLongitude
                          ? 'hover:bg-slate-100 text-green-600'
                          : 'text-slate-300 cursor-not-allowed'
                      }`}
                      title="Ver en Google Maps"
                    >
                      <Eye className="h-4 w-4" />
                    </button>
                  </div>
                </div>
              </div>

              {/* Distrito */}
              <div>
                <label className="flex items-center gap-2 mb-3 text-sm font-semibold text-slate-800 font-montserrat">
                  <MapPin className="h-4 w-4" style={{ color: brand.accentGreen }} />
                  Distrito *
                </label>
                <select
                  value={district}
                  onChange={(e) => {
                    setDistrict(e.target.value);
                    setErrorMessage('');
                  }}
                  className="w-full rounded-xl border-2 border-slate-200 bg-white px-4 py-3 text-sm focus:outline-none focus:border-[#67A43C] transition-all font-montserrat"
                >
                  <option value="">Selecciona un distrito</option>
                  {DISTRICTS.map((d) => (
                    <option key={d} value={d}>{d}</option>
                  ))}
                </select>
              </div>

              {/* Productos */}
              <div>
                <label className="flex items-center gap-2 mb-3 text-sm font-semibold text-slate-800 font-montserrat">
                  <Package className="h-4 w-4" style={{ color: brand.primary }} />
                  Productos del paquete *
                </label>
                <button
                  type="button"
                  onClick={() => setOpenProductsDialog(true)}
                  className="w-full rounded-xl border-2 border-slate-200 bg-white px-4 py-3 text-left text-sm hover:border-slate-300 transition-all"
                >
                  {items.length ? (
                    <div className="flex flex-wrap gap-2">
                      {items.map((i, idx) => (
                        <span key={idx} className="inline-flex items-center gap-1 bg-slate-100 px-2 py-1 rounded-lg text-xs font-montserrat">
                          {i.quantity}x {i.title}
                        </span>
                      ))}
                    </div>
                  ) : (
                    <span className="text-slate-400 font-montserrat">Selecciona productos...</span>
                  )}
                </button>
              </div>

              {/* Cargo */}
              <div>
                <label className="flex items-center gap-2 mb-3 text-sm font-semibold text-slate-800 font-montserrat">
                  <DollarSign className="h-4 w-4" style={{ color: brand.accentGold }} />
                  Cargo (S/.)
                  <span className="text-xs font-normal text-slate-500">(opcional)</span>
                </label>
                <input
                  type="text"
                  value={charge}
                  onChange={(e) => {
                    const valid = e.target.value.replace(/[^0-9.]/g, '');
                    setCharge(valid);
                  }}
                  placeholder="12.50"
                  className="w-full rounded-xl border-2 border-slate-200 bg-white px-4 py-3 text-sm focus:outline-none focus:border-[#E6B43C] transition-all font-montserrat"
                />
              </div>

              {/* Notas */}
              <div>
                <label className="flex items-center gap-2 mb-3 text-sm font-semibold text-slate-800 font-montserrat">
                  <FileText className="h-4 w-4" style={{ color: brand.accentGreen }} />
                  Notas adicionales
                  <span className="text-xs font-normal text-slate-500">(opcional)</span>
                </label>
                <textarea
                  rows={3}
                  value={additionalNotes}
                  onChange={(e) => setAdditionalNotes(e.target.value)}
                  placeholder="Información adicional para la entrega..."
                  className="w-full rounded-xl border-2 border-slate-200 bg-white px-4 py-3 text-sm focus:outline-none focus:border-[#67A43C] transition-all resize-none font-montserrat"
                  maxLength={500}
                />
                <p className="mt-1 text-xs text-slate-400 text-right font-montserrat">
                  {additionalNotes.length}/500
                </p>
              </div>

              {/* Error */}
              {errorMessage && (
                <div className="flex items-start gap-2 rounded-xl bg-red-50 border border-red-200 px-4 py-3">
                  <AlertCircle className="h-4 w-4 text-red-600 mt-0.5 flex-shrink-0" />
                  <p className="text-sm text-red-700 font-montserrat">{errorMessage}</p>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      {/* Footer */}
      <div className="bg-white border-t border-slate-200 shadow-lg">
        <div className="mx-auto max-w-4xl px-4 py-4 sm:px-6">
          <div className="flex gap-3 justify-end">
            <button
              type="button"
              onClick={() => setActiveComponent('Analytics')}
              className="rounded-xl border-2 border-slate-300 bg-white px-6 py-2.5 text-sm font-semibold text-slate-700 hover:bg-slate-50 transition-colors font-montserrat"
            >
              Cancelar
            </button>
            <button
              type="button"
              onClick={handleConfirmClick}
              disabled={busy}
              className="rounded-xl px-6 py-2.5 text-sm font-semibold text-white shadow-md hover:shadow-lg disabled:opacity-50 disabled:cursor-not-allowed transition-all font-montserrat"
              style={{ backgroundColor: brand.primary }}
            >
              {busy ? "Procesando..." : "Confirmar Entrega"}
            </button>
          </div>
        </div>
      </div>

      {/* Confirmation Modal */}
      {isModalOpen && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 p-4 backdrop-blur-sm">
          <div className="w-full max-w-md rounded-2xl bg-white shadow-2xl">
            <div className="p-6">
              <div className="flex items-center gap-3 mb-4">
                <div className="flex h-12 w-12 items-center justify-center rounded-full" style={{ backgroundColor: `${brand.primary}20` }}>
                  <Package className="h-6 w-6" style={{ color: brand.primary }} />
                </div>
                <h3 className="text-lg font-bold font-montserrat" style={{ color: brand.primary }}>
                  Confirmar Entrega
                </h3>
              </div>
              <p className="text-sm text-slate-600 mb-6 font-montserrat">
                ¿Está seguro de que la información ingresada es correcta?
              </p>
              <div className="flex gap-3">
                <button
                  onClick={() => setIsModalOpen(false)}
                  className="flex-1 rounded-xl border-2 border-slate-300 bg-white px-4 py-2.5 text-sm font-semibold text-slate-700 hover:bg-slate-50 transition-colors font-montserrat"
                >
                  Revisar
                </button>
                <button
                  onClick={handleConfirm}
                  className="flex-1 rounded-xl px-4 py-2.5 text-sm font-semibold text-white shadow-md hover:shadow-lg transition-all font-montserrat"
                  style={{ backgroundColor: brand.primary }}
                >
                  Confirmar
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Success Modal */}
      {showSuccessModal && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 p-4 backdrop-blur-sm">
          <div className="w-full max-w-md rounded-2xl bg-white shadow-2xl">
            <div className="p-6">
              <div className="flex items-center gap-3 mb-4">
                <div className="flex h-12 w-12 items-center justify-center rounded-full bg-green-100">
                  <CheckCircle className="h-6 w-6 text-green-600" />
                </div>
                <h3 className="text-lg font-bold font-montserrat text-green-600">
                  ¡Entrega Creada!
                </h3>
              </div>
              <p className="text-sm text-slate-600 mb-6 font-montserrat">
                La entrega se ha registrado exitosamente. ¿Qué deseas hacer ahora?
              </p>
              <div className="flex flex-col gap-3">
                <button
                  onClick={handleAddAnother}
                  className="w-full rounded-xl px-4 py-2.5 text-sm font-semibold text-white shadow-md hover:shadow-lg transition-all font-montserrat"
                  style={{ backgroundColor: brand.primary }}
                >
                  Agregar Otra Entrega
                </button>
                <button
                  onClick={() => setActiveComponent('Analytics')}
                  className="w-full rounded-xl border-2 border-slate-300 bg-white px-4 py-2.5 text-sm font-semibold text-slate-700 hover:bg-slate-50 transition-colors font-montserrat"
                >
                  Ver Mis Entregas
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      <MultiProductDialog
        open={openProductsDialog}
        onClose={closeDialogProduct}
        onSave={handleSaveItems}
        userId={userId}
        initialItems={items}
        canAddProduct={!!(user && !user.provider_id)}
      />
    </div>
  );
}